import TagManager from "react-gtm-module";

let startTime = Date.now();

export const initAnalyticsBridge = () => {
  if (window.__ANALYTICS__) return;

  let currentUserId = null;
  let currentTenantId = null;

  let currentPage = window.location.pathname;

  window.__ANALYTICS__ = {
    setUser(user) {
      currentUserId = user?.user_id || null;
      currentTenantId = user?.tenant_id || null;
    },

    setPage(path) {
      currentPage = path;
    },

    featureUsed(featureProps = {}) {
      if (!currentUserId) return;

      TagManager.dataLayer({
        dataLayer: {
          event: "feature_used",
          scai_user: currentUserId,
          scai_tenant: currentTenantId,
          page_path: currentPage,
          ...featureProps,
        },
      });
    },

    pageTimeSpent(seconds) {
      if (!currentUserId || seconds <= 0) return;

      TagManager.dataLayer({
        dataLayer: {
          event: "page_time_spent",
          scai_user: currentUserId,
          scai_tenant: currentTenantId,
          page_path: currentPage,
          time_spent_seconds: seconds,
        },
      });
    },
  };
};

export const initPageTimeTracking = () => {
  const track = () => {
    const seconds = Math.round((Date.now() - startTime) / 1000);
    window.__ANALYTICS__?.pageTimeSpent(seconds);
  };

  window.addEventListener("mfe:navigation", () => {
    track();
    startTime = Date.now();
  });

  window.addEventListener("beforeunload", track);

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      track();
    } else {
      startTime = Date.now();
    }
  });
};
